import React from 'react';

const HomeRtes2 = props => {
  return (
    <div>

    </div>
  )
}

export default HomeRtes2